import _asyncToGenerator from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.split.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getToken } from '@/utils/auth';
import { fetchEventSource } from '@microsoft/fetch-event-source';
export default {
  data: function data() {
    return {
      isShowBtnGroup: false,
      question: '',
      answer: '',
      answerMsg: [],
      images: '',
      assistantImages: require('../../assets/qaRobot.png'),
      items: [],
      systemList: JSON.parse(sessionStorage.getItem('systemInner')),
      disClick: false,
      breakPromise: false,
      cancelBtn: null,
      skeleton: false,
      options: {
        assistant: '晓合助手',
        riQa: '合规政策问答',
        instQa: '制度问答'
      },
      sys: 'question',
      chatId: '',
      delay: true,
      model: 'assistant',
      change: false,
      isSend: false,
      sendModel: 'assistant',
      instAnswerMsg: [],
      riAnswerMsg: []
    };
  },
  created: function created() {
    var _this = this;
    this.chatId = this.guid();
    this.sys = this.$route.query.sys;
    this.$API.getRequest({
      url: '/platform/todo/photo'
    }).then(function (res) {
      _this.images = res.result.imageBase64;
    });
    // this.answerMsg = this.$route.params.answerMsg || []
  },

  methods: {
    getQuestion: function getQuestion(msg) {
      if (this.disClick) {
        return;
      }
      this.question = msg;
      this.sendBtn();
    },
    sendBtn: function sendBtn() {
      this.answer = '';
      if (this.disClick || this.question.trim().length === 0) {
        return;
      }
      this.change = true;
      if (!this.isSend) this.sendModel = this.model;
      this.isSend = true;
      if (this.model === 'assistant') {
        this.sendChat();
      } else if (this.model === 'instQa') {
        this.sendMsgInst();
      } else {
        this.sendMsgRi();
      }
    },
    clearSessionId: function clearSessionId() {
      var _this2 = this;
      return new Promise(function (resolve) {
        // $.ajax({
        //   type:"post",
        //   url:'/assistant/clear_session/'+`${sessionId}`,
        //   success:function(res){
        //     if(res.code === '200'){
        //       resolve(res)
        //     }
        //   }
        // })
        _this2.$API.postRequest({
          // eslint-disable-next-line no-useless-concat
          url: '/assistant/clear_session/' + "".concat(chatId)
        }).then(function (res) {
          if (res.code === '200') {
            resolve(res);
          }
        });
      });
    },
    checkModel: function checkModel(model) {
      var _this3 = this;
      if (this.model === model) {
        return;
      }
      setTimeout(function () {
        for (var i = 0; i < 10; i++) {
          _this3.$forceUpdate();
          _this3.add();
          _this3.$forceUpdate();
        }
      });
      this.model = model;
    },
    cancelQa: function cancelQa() {
      this.disClick = false;
      that.skeleton = false;
      this.answer = '';
      this.cancelBtn.abort();
      this.$refs.inputName.focus();
    },
    toInst: function toInst(ele) {
      var path = ele.systemId === 'LC_IE' ? "/instDetail?instId=".concat(ele.id) : "/systemDetails?id=".concat(ele.id);
      this.systemList.forEach(function (item) {
        if (item && item.systemId === ele.systemId) {
          window.open(decodeURIComponent("".concat(window.location.origin, "/?newPage=").concat(item.baseUrl, "&menuPath=").concat(path, "&isHash=").concat(ele.systemId === 'LC_IE' ? 1 : 0)));
        }
      });
    },
    add: function add() {
      var div = document.getElementById('drawContentScroll');
      if (this.model === 'assistant') {
        div = document.getElementById('drawContentScroll');
      } else if (this.model === 'instQa') {
        div = document.getElementById('instDrawContentScroll');
      } else if (this.model === 'riQa') {
        div = document.getElementById('riDrawContentScroll');
      }
      div.scrollIntoView({
        block: 'end',
        inline: 'nearest'
      });
      // div.scrollTop = div.scrollHeight;
    },
    carriageReturn: function carriageReturn() {
      // eslint-disable-next-line prefer-rest-params
      var e = window.event || arguments[0];
      // console.log(e,e.keyCode)
      if (e.key === 'Enter' || e.code === 'Enter' || e.keyCode === 13) {
        e.returnValue = false;
        this.sendBtn();
        return false;
      }
    },
    guid: function guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-mixed-operators,no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    },
    sendMsgInst: function sendMsgInst() {
      var _this4 = this;
      this.disClick = true;
      var that = this;
      if (this.question === '') {
        this.$message({
          message: '请输入您的问题',
          type: 'warning'
        });
        this.disClick = false;
        return;
      }
      // eslint-disable-next-line no-unused-vars
      var url = window.location.href;
      this.instAnswerMsg.push({
        msg: this.question,
        type: 'right',
        title: null,
        images: this.images
      });
      setTimeout(function () {
        for (var i = 0; i < 5; i++) {
          _this4.$forceUpdate();
          _this4.add();
          _this4.$forceUpdate();
        }
      }, 30);
      this.$forceUpdate();
      this.add();
      // eslint-disable-next-line no-unused-vars
      var RetriableError = /*#__PURE__*/function (_Error) {
        _inherits(RetriableError, _Error);
        var _super = _createSuper(RetriableError);
        function RetriableError() {
          _classCallCheck(this, RetriableError);
          return _super.apply(this, arguments);
        }
        return RetriableError;
      }( /*#__PURE__*/_wrapNativeSuper(Error));
      var FatalError = /*#__PURE__*/function (_Error2) {
        _inherits(FatalError, _Error2);
        var _super2 = _createSuper(FatalError);
        function FatalError() {
          _classCallCheck(this, FatalError);
          return _super2.apply(this, arguments);
        }
        return FatalError;
      }( /*#__PURE__*/_wrapNativeSuper(Error));
      var ctrl = new AbortController();
      this.cancelBtn = ctrl;
      fetchEventSource('/assistant/qa/question-stream', {
        // fetchEventSource( 'http://172.19.218.187:9530/hexasino-assistant-qa/qa/question-stream' , {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Connection: 'keep-alive',
          Authorization: "bearer ".concat(getToken())
        },
        body: JSON.stringify({
          session_id: that.guid(),
          //
          query: that.question.trim(),
          // 云闪贷的操作流程
          knowledges: ['internal_clause_knowledge', 'external_clause_knowledge', 'lc_llm'] // instQa
        }),

        openWhenHidden: true,
        retry: false,
        signal: ctrl.signal,
        onopen: function onopen(response) {
          return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    // that.$refs.msg_end.click();
                    if (response.ok) {
                      that.question = '';
                      that.instAnswerMsg.push({
                        title: [],
                        msg: '',
                        type: 'left'
                      });
                    }
                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }))();
        },
        onmessage: function onmessage(msg) {
          if (msg.data.indexOf('response started') > -1) {
            var title = msg.data.split('[response started]')[0];
            // eslint-disable-next-line no-eval
            that.instAnswerMsg[that.instAnswerMsg.length - 1].title = eval(title);
          } else {
            if (msg.data.indexOf('DONE') > -1) {
              that.answer = '';
              return;
            }
            if (msg.data.indexOf('NEWLINE') > -1) {
              // that.$refs.msg_end.click();
            }
            that.answer += msg.data.replace(/\[NEWLINE\]/g, '<br>');
            that.instAnswerMsg[that.instAnswerMsg.length - 1].msg = that.answer;
            that.$forceUpdate();
            that.add();

            // if the server emits an error message, throw an exception
            // so it gets handled by the onerror callback below:
            if (msg.event === 'FatalError') {
              throw new FatalError(msg.data);
            }
          }
        },
        onclose: function onclose() {
          // if the server closes the connection unexpectedly, retry:
          // that.$refs.msg_end.click();
          that.disClick = false;
          that.$refs.inputName.focus();
        },
        onerror: function onerror() {
          that.breakPromise = false;
          // that.$refs.searchInput.focus()
          throw new FatalError('xxx');
        }
      });
    },
    sendMsgRi: function sendMsgRi() {
      var _this5 = this;
      this.disClick = true;
      var that = this;
      if (this.question === '') {
        this.$message({
          message: '请输入您的问题',
          type: 'warning'
        });
        this.disClick = false;
        return;
      }
      // eslint-disable-next-line no-unused-vars
      var url = window.location.href;
      this.riAnswerMsg.push({
        msg: this.question,
        type: 'right',
        title: null,
        images: this.images
      });
      setTimeout(function () {
        for (var i = 0; i < 5; i++) {
          _this5.$forceUpdate();
          _this5.add();
          _this5.$forceUpdate();
        }
      }, 30);
      this.$forceUpdate();
      this.add();
      // eslint-disable-next-line no-unused-vars
      var RetriableError = /*#__PURE__*/function (_Error3) {
        _inherits(RetriableError, _Error3);
        var _super3 = _createSuper(RetriableError);
        function RetriableError() {
          _classCallCheck(this, RetriableError);
          return _super3.apply(this, arguments);
        }
        return RetriableError;
      }( /*#__PURE__*/_wrapNativeSuper(Error));
      var FatalError = /*#__PURE__*/function (_Error4) {
        _inherits(FatalError, _Error4);
        var _super4 = _createSuper(FatalError);
        function FatalError() {
          _classCallCheck(this, FatalError);
          return _super4.apply(this, arguments);
        }
        return FatalError;
      }( /*#__PURE__*/_wrapNativeSuper(Error));
      var ctrl = new AbortController();
      this.cancelBtn = ctrl;
      fetchEventSource('/assistant/qa/question-stream', {
        // fetchEventSource( 'http://172.19.218.187:9530/hexasino-assistant-qa/qa/question-stream' , {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Connection: 'keep-alive',
          Authorization: "bearer ".concat(getToken())
        },
        body: JSON.stringify({
          session_id: that.guid(),
          //
          query: that.question.trim(),
          // 云闪贷的操作流程
          knowledges: ['external_clause_knowledge'] // instQa
        }),

        openWhenHidden: true,
        retry: false,
        signal: ctrl.signal,
        onopen: function onopen(response) {
          return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    // that.$refs.msg_end.click();
                    if (response.ok) {
                      that.question = '';
                      that.riAnswerMsg.push({
                        title: [],
                        msg: '',
                        type: 'left'
                      });
                    }
                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }))();
        },
        onmessage: function onmessage(msg) {
          if (msg.data.indexOf('response started') > -1) {
            var title = msg.data.split('[response started]')[0];
            // eslint-disable-next-line no-eval
            that.riAnswerMsg[that.riAnswerMsg.length - 1].title = eval(title);
          } else {
            if (msg.data.indexOf('DONE') > -1) {
              that.answer = '';
              return;
            }
            if (msg.data.indexOf('NEWLINE') > -1) {
              // that.$refs.msg_end.click();
            }
            that.answer += msg.data.replace(/\[NEWLINE\]/g, '<br>');
            that.riAnswerMsg[that.riAnswerMsg.length - 1].msg = that.answer;
            that.$forceUpdate();
            that.add();

            // if the server emits an error message, throw an exception
            // so it gets handled by the onerror callback below:
            if (msg.event === 'FatalError') {
              throw new FatalError(msg.data);
            }
          }
        },
        onclose: function onclose() {
          // if the server closes the connection unexpectedly, retry:
          // that.$refs.msg_end.click();
          that.disClick = false;
          that.$refs.inputName.focus();
        },
        onerror: function onerror() {
          that.breakPromise = false;
          // that.$refs.searchInput.focus()
          throw new FatalError('xxx');
        }
      });
    },
    sendChat: function sendChat() {
      var _this6 = this;
      this.disClick = true;
      var that = this;
      if (this.question === '') {
        this.$message({
          message: '请输入您的问题',
          type: 'warning'
        });
        this.disClick = false;
        return;
      }
      // eslint-disable-next-line no-unused-vars
      var url = window.location.href;
      this.answerMsg.push({
        msg: this.question,
        type: 'right',
        title: null,
        images: this.images
      });
      this.$forceUpdate();
      this.add();
      setTimeout(function () {
        for (var i = 0; i < 5; i++) {
          _this6.$forceUpdate();
          _this6.add();
          _this6.$forceUpdate();
        }
      }, 30);
      // eslint-disable-next-line no-unused-vars
      var RetriableError = /*#__PURE__*/function (_Error5) {
        _inherits(RetriableError, _Error5);
        var _super5 = _createSuper(RetriableError);
        function RetriableError() {
          _classCallCheck(this, RetriableError);
          return _super5.apply(this, arguments);
        }
        return RetriableError;
      }( /*#__PURE__*/_wrapNativeSuper(Error));
      var FatalError = /*#__PURE__*/function (_Error6) {
        _inherits(FatalError, _Error6);
        var _super6 = _createSuper(FatalError);
        function FatalError() {
          _classCallCheck(this, FatalError);
          return _super6.apply(this, arguments);
        }
        return FatalError;
      }( /*#__PURE__*/_wrapNativeSuper(Error));
      var ctrl = new AbortController();
      this.cancelBtn = ctrl;
      fetchEventSource('/assistant/chat', {
        // fetchEventSource( 'http://172.19.218.187:9530/hexasino-assistant-qa/qa/question-stream' , {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Connection: 'keep-alive',
          Authorization: "bearer ".concat(getToken())
        },
        body: JSON.stringify({
          session_id: that.chatId,
          //
          prompt: that.question.trim() // 云闪贷的操作流程
        }),

        openWhenHidden: true,
        retry: false,
        signal: ctrl.signal,
        onopen: function onopen(response) {
          return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    // that.$refs.msg_end.click();
                    if (response.ok) {
                      that.question = '';
                      that.answerMsg.push({
                        title: [],
                        msg: '',
                        type: 'left'
                      });
                    }
                  case 1:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }))();
        },
        onmessage: function onmessage(msg) {
          that.$nextTick(function () {
            // setTimeout(()=>{
            if (msg.data.indexOf('DONE') > -1) {
              that.answer = '';
              return;
            }
            that.answer += msg.data.replace(/\[NEWLINE\]/g, '<br>');
            that.answerMsg[that.answerMsg.length - 1].msg = that.answer;
            that.$forceUpdate();
            that.add();
            // },100)
          });

          // if the server emits an error message, throw an exception
          // so it gets handled by the onerror callback below:
          if (msg.event === 'FatalError') {
            throw new FatalError(msg.data);
          }
        },
        onclose: function onclose() {
          // if the server closes the connection unexpectedly, retry:
          // that.$refs.msg_end.click();
          that.disClick = false;
          that.$refs.inputName.focus();
        },
        onerror: function onerror() {
          that.breakPromise = false;
          // that.$refs.searchInput.focus()
          throw new FatalError('xxx');
        }
      });
    }
  },
  computed: {
    user: function user() {
      return this.$store.state.settings.userinfo;
    }
  }
};